export const numericActionTypes = {
  changeByPercent: 'ChangeByPercent',
  changeByAmount: 'ChangeByAmount',
  setAmount: 'SetToAmount',
};
